import React from 'react';
import { range } from 'lodash/util';
import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Hidden,
    Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Translator from '%app/js/common/services/translator';

function CountSelector(props) {
    const {
        min,
        max,
        currentCount,
        selectCount,
        classes,
    } = props;

    if (min === null && max === null && selectCount === null) {
        return (
            <React.Fragment>
                <Hidden mdUp>
                    <Typography
                        display="inline"
                        color="textSecondary"
                        variant="body2"
                        className={classes.mobileTitle}
                    >
                        {Translator.trans('seat_selection_integration.cart.count')}
                        {':'}
                    </Typography>
                </Hidden>
                <Typography display="inline">{currentCount}</Typography>
            </React.Fragment>
        );
    }

    return (
        <FormControl fullWidth>
            <Hidden mdUp>
                <InputLabel>{Translator.trans('seat_selection_integration.cart.count')}</InputLabel>
            </Hidden>
            <Select
                onChange={({ target: { value } }) => selectCount(value)}
                value={currentCount}
                fullWidth
            >
                {range(min, max + 1).map(count => (
                    <MenuItem value={count} key={`count-${count}`}>
                        {count}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

CountSelector.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    currentCount: PropTypes.number.isRequired,
    selectCount: PropTypes.func,
    classes: PropTypes.shape({
        mobileTitle: PropTypes.string,
    }).isRequired,
};

CountSelector.defaultProps = {
    min: null,
    max: null,
    selectCount: null,
};

export default CountSelector;
